import React, {useContext} from 'react'
import * as Yup from "yup"
import { useFormik } from 'formik'
import { AuthContext } from '../../../context/AuthContext'
import Navbar from '../../navbar/Navbar'
import { useParams } from 'react-router-dom'


const formShema = Yup.object({
    password: Yup.string().required().min(6, "characters must not less than 6").max(15, "characters must not more than 15")
})

const NewPassword = () => {

    const {newPassword, errorResetPassword} = useContext(AuthContext)
    const {id} = useParams()

    const formik = useFormik({
        initialValues: {
             password: "",
        },
        onSubmit: (values) => {
            const data = {
                password: values.password,
                token: id
            }
            newPassword(data)
        },
        validationSchema: formShema
   })

  return (
    <div className="container">
    <Navbar />
    <div className="columns is-flex is-justify-content-center">
         <div className="column is-two-fifths">
              <h1 
              className='has-text-white is-size-3 has-text-centered mb-6 mt-5 pt-5'>
                   Reset Password Form
              </h1>
              <form onSubmit={formik.handleSubmit} className='p-6 has-background-dark box'>
                    <h1 className='has-text-white is-size-4 has-text-centered mb-6'>
                        Enter your password
                    </h1>

                    <h1 className='has-text-danger is-size-5 has-text-centered mb-2'>
                        {errorResetPassword}
                    </h1>

                   <div className="field">
                        <label className="label"> Password </label>
                        <div className="control">
                        <input 
                        type="password"
                         className='input'
                          placeholder='Your Password'
                          value={formik.values.password}
                          onChange={formik.handleChange("password")}
                          onBlur={formik.handleBlur("password")}
                          />
                          <p className='help is-danger'>
                               {formik.touched.password && formik.errors.password}
                          </p>
                        </div>
                   </div>

                   <div className="field">
                        <button 
                        className='button is-success is-fullwidth mt-5'
                         type='submit'> Change password  </button>
                   </div>
              </form>
         </div>
    </div>
</div>
  )
}

export default NewPassword
